import styled from 'styled-components';

export const Container = styled.div``;
export const Buttons = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-shrink: 0;

  gap: 1rem;

  @media screen and (max-width: ${(props) => props.theme.size?.medium}) {
    padding-bottom: 0.5rem;
  }
`;

export const ContentMovimentation = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 0;
  gap: 1rem;
`;

export const MovementHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  width: 100%;
`;

export const AttachmentsEnd = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.5rem;
  flex-shrink: 0;
`;

export const ContainerFocus = styled.div`
  padding-top: 1rem;

  animation: fadeIn 1s;
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  opacity: 1;
`;

export const ContentFocus = styled.div``;

export const DivAnexos = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const H6 = styled.h6``;

export const AttachmentName = styled.h6`
  word-break: break-word;
  text-align: right;
`;

export const H6Break = styled.h6`
  word-break: break-word;
`;

export const AlertTitleRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem 4.25rem;
  width: 100%;

  @media screen and (max-width: ${({ theme }) => theme.size?.medium}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.35rem;
  }
`;

export const ProtocolText = styled.span<{ $lightText?: boolean }>`
  color: ${({ theme, $lightText }) =>
    $lightText
      ? theme.colors?.backgroundColor
      : theme.colors?.text?.secondary ?? theme.colors?.gray02};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  font-weight: 600;
  white-space: nowrap;
`;

export const DateText = styled.span<{ $lightText?: boolean }>`
  color: ${({ theme, $lightText }) =>
    $lightText
      ? theme.colors?.backgroundColor
      : theme.colors?.text?.secondary ?? theme.colors?.gray02};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  font-weight: 600;
  white-space: nowrap;
`;

export const TitleText = styled.span<{ $lightText?: boolean }>`
  color: ${({ theme, $lightText }) =>
    $lightText
      ? theme.colors?.backgroundColor
      : theme.colors?.text?.primary ?? theme.colors?.gray01};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  font-weight: 600;
  word-break: break-word;
  flex: 1;
  min-width: 10rem;
`;

export const ToggleIcon = styled.div<{ $lightText?: boolean }>`
  display: flex;
  align-items: center;
  color: ${({ theme, $lightText }) =>
    $lightText
      ? theme.colors?.backgroundColor
      : theme.colors?.text?.secondary ?? theme.colors?.gray02};
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;

  @media screen and (max-width: ${({ theme }) => theme.size?.medium}) {
    flex-direction: column;
  }
`;
